import {Injectable} from '@angular/core';
import {Observable, of, throwError} from "rxjs";
import {emptyFinanceReportBalance, emptyFinanceReportMarginality, emptyFinanceReportOpu, emptyFinanceReportRevenue, IFinanceReportBalance, IFinanceReportMarginality, IFinanceReportOpu, IFinanceReportRevenue} from "@retail-data-factory/rdf-angular-types-api";
import {mockFinanceReportBalance, mockFinanceReportMarginality, mockFinanceReportOpu, mockFinanceReportRevenue} from "./mock-finance";
import {Presenter} from "../../../internal/presenter/presenter";
import {emptyRdfServiceResponseError, IRdfServiceResponseError} from "../../../../services/external-api/response-interfaces";

@Injectable({
  providedIn: 'root'
})
export class ApiFinanceService {

  constructor(public presenter: Presenter) {
  }

  getReportOpu(dateFrom: Date, DateTo: Date): Observable<IFinanceReportOpu> {
    const dataSourcePartyId = this.presenter.getSelectedDataSourcePartner().partyId;
    if (dataSourcePartyId !== '8643') {
      return of(mockFinanceReportOpu);
    } else {
      const error: IRdfServiceResponseError = {
        ...emptyRdfServiceResponseError,
        isHttpError: true,
        errorCode: 403
      };
      return throwError(error);

    }

  }

  getReportBalance(dateFrom: Date, DateTo: Date): Observable<IFinanceReportBalance> {
    const dataSourcePartyId = this.presenter.getSelectedDataSourcePartner().partyId;
    if (dataSourcePartyId !== '8643') {
      return of(mockFinanceReportBalance);
    } else {
      const error: IRdfServiceResponseError = {
        ...emptyRdfServiceResponseError,
        isHttpError: true,
        errorCode: 403
      };
      return throwError(error);

    }
  }

  getReportRevenue(dateFrom: Date, DateTo: Date): Observable<IFinanceReportRevenue> {
    const dataSourcePartyId = this.presenter.getSelectedDataSourcePartner().partyId;
    if (dataSourcePartyId !== '8643') {
      return of(mockFinanceReportRevenue);
    } else {
      const error: IRdfServiceResponseError = {
        ...emptyRdfServiceResponseError,
        isHttpError: true,
        errorCode: 403
      };
      return throwError(error);

    }
  }

  getReportMarginality(dateFrom: Date, DateTo: Date): Observable<IFinanceReportMarginality> {
    const dataSourcePartyId = this.presenter.getSelectedDataSourcePartner().partyId;
    if (dataSourcePartyId !== '8643') {
      return of(mockFinanceReportMarginality);
    } else {
      const error: IRdfServiceResponseError = {
        ...emptyRdfServiceResponseError,
        isHttpError: true,
        errorCode: 403
      };
      return throwError(error);

    }
  }

  getReportClients(dateFrom: Date, DateTo: Date): Observable<any> {
    const dataSourcePartyId = this.presenter.getSelectedDataSourcePartner().partyId;
    if (dataSourcePartyId === '8642') {
      return of(null);
    } else {
      const error: IRdfServiceResponseError = {
        ...emptyRdfServiceResponseError,
        isHttpError: true,
        errorCode: 403
      };
      return throwError(error);

    }
  }

}
